import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OrganisationServiceService } from '../../services/organisation-service.service';
import { SkiTrail } from '../../../models/types';
import { Observable, of } from 'rxjs';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCircleInfo, faInfo, faMountain, faRuler, faTrash } from '@fortawesome/free-solid-svg-icons';
@Component({
  selector: 'app-proge',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, FontAwesomeModule],
  templateUrl: './proge.component.html',
  styleUrl: './proge.component.scss'
})
export class ProgeComponent {
  @Input() isAdmin: boolean = false;

  skiTrails: SkiTrail[] = [];
  skiTrailForm: FormGroup;
  showAddTrail: boolean = false;

  faMountain = faMountain;
  faRuler = faRuler;
  faCircleInfo = faCircleInfo;
  faTrash = faTrash;

  expandedTrailId: number | null = null;

  constructor(private organisationService: OrganisationServiceService, private fb: FormBuilder) {
    this.skiTrailForm = this.fb.group({
      name: ['', Validators.required],
      length: [0, [Validators.required, Validators.min(0)]],
      difficulty: ['', Validators.required],
      description: ['', Validators.required],
      imageUrl: [''],
      elevation: [0, [Validators.required, Validators.min(0)]],
      available: [false],
      classic: [false],
      skating: [false],
      condition: ['', Validators.required]
    });
  }

  ngOnInit() {
    this.getSkiTrails();
  }

  getSkiTrails() {
    this.organisationService.getSkiTrails().subscribe({
      next: (response) => {
        this.skiTrails = response;
        console.log('Ski Trails:', this.skiTrails);
      },
      error: (err) => {
        console.error('Failed to fetch ski trails:', err);
      }
    });
  }

  addSkiTrail() {
    if (this.skiTrailForm.valid) {
      const newTrail: SkiTrail = this.skiTrailForm.value;
      this.organisationService.addSkiTrail(newTrail).subscribe({
        next: (response) => {
          console.log('Ski Trail added:', response);
          this.skiTrails.push(newTrail);
          this.skiTrailForm.reset();
        },
        error: (err) => {
          console.error('Failed to add ski trail:', err);
        }
      });
    } else {
      console.log('Invalid form submission');
    }
  }

  deleteSkiTrail(skiTrailID: number) {
    this.organisationService.deleteSkiTrail(skiTrailID).subscribe({
      next: (response) => {
        console.log('Ski Trail deleted:', response);
        this.skiTrails = this.skiTrails.filter(trail => trail.id !== skiTrailID);
      },
      error: (err) => {
        console.error('Failed to delete ski trail:', err);
      }
    });
  }

  toggleSkiTrailAvailability(skiTrailID: number) {
    this.organisationService.toggleSkiTrailAvailability(skiTrailID).subscribe({
      next: (response) => {
        console.log('Ski Trail availability toggled:', response);
        this.skiTrails = this.skiTrails.map(trail =>
          trail.id === skiTrailID ? { ...trail, available: !trail.available } : trail
        );
      },
      error: (err) => {
        console.error('Failed to toggle ski trail availability:', err);
      }
    });
  }

  toggleAddTrail() {
    this.showAddTrail = !this.showAddTrail;
  }

  toggleExpandedTrail(trailId: number): void {
    this.expandedTrailId = this.expandedTrailId === trailId ? null : trailId;
  }
  
}